import api from 'api/instance';
import { ActivityType } from 'types/activity';

const URL = `${process.env.REACT_APP_API_URL}/activity/types`;

export const getActivityTypes = async (): Promise<ActivityType[]> => {
  const { data } = await api.get<ActivityType[]>(URL);
  return data;
};